define('toolkit/b-panel/b-panel',
		[
			'toolkit/b-toolkit/b-toolkit',
			'toolkit/b-controls/b-controls',
			'toolkit/extensions/extensions'
		], function (toolkit) {
			'use strict';

			return toolkit.create( 'b-panel', {

				templateBlock: 'b-panel',
				renderMode: 'replace',

				init: function () {
					this.controls = toolkit['b-controls'].wrap(this.el);

					this._initElems();
				},

				onRender: function() {
					this._initElems();
				},

				_initElems: function() {
					this.$error = this.$el.find('.b-panel__error');
					this.$desc = this.$('.b-panel__content__desc');
				},

				showError: function (msg) {
					this.$error.text(msg).display('block');
				},

				hideError: function () {
					this.$error.display(false);
				},

				disableNext: function () {
					this.controls.disableNext();
				},

				enableNext: function () {
					this.controls.enableNext();
				},

				/**
				 * Устанавливаем новый текст в блок с описанием
				 *
				 * @param {string} text
				 * @param {boolean} isHtml если true то можно вписывать html
				 */
				setDescription: function(text, isHtml) {
					this.$desc[isHtml ? 'html' : 'text'](text);
				},

				/**
				 * Возвращает текущее состояние вида
				 * если мобильный вид, то 'phone'
				 * если обычный то ''
				 */
				getMedia: function () {
					if (this.$('__media').css('display') === 'none') {
						return 'phone';
					} else {
						return '';
					}
				}
			});
		});
